export enum RecommendationLocation {
    HOME_PAGE = 'homepage',
    PDP = 'pdp',
    DRAWER = 'drawer',
    PDP_ERROR = 'pdp-error',
    SHOPPING_BAG = 'shopping-bag',
    PLP = 'plp',
    SEARCH_RESULTS = 'search-results',
    SEARCH_NO_RESULTS = 'search-no-results',
    SAVE_FOR_LATER = 'save-for-later',
}
